import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { startNativePush } from './nativePush';

/** 在 AppRoutes 里调用一次：登录后自动启动安卓前台推送服务（非 APK 环境自动跳过） */
export function useNativePush() {
  const { user } = useAuth();
  useEffect(() => {
    if (user) startNativePush(user);
  }, [user?.id]); // eslint-disable-line react-hooks/exhaustive-deps
}
